import { Injectable, inject } from '@angular/core';
import { Firestore, collection, collectionData, addDoc, doc, updateDoc } from '@angular/fire/firestore';
import { Storage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from '@angular/fire/storage';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArtistService {
  private firestore = inject(Firestore);
  private storage = inject(Storage);
  private collectionName = 'artists';

  getArtists(): Observable<any[]> {
    const col = collection(this.firestore, this.collectionName);
    return collectionData(col, { idField: 'id' }) as Observable<any[]>;
  }

  async addArtist(artist: any): Promise<any> {
    const col = collection(this.firestore, this.collectionName);
    return addDoc(col, { ...artist, createdAt: new Date(), files: [] });
  }

  async updateArtist(id: string, data: any): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, data);
  }

  async deleteArtist(id: string): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, { isDeleted: true });
  }

  async updateArtistFiles(id: string, files: any[]): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, { files, updatedAt: new Date() });
  }

  uploadFile(artistId: string, file: File, onProgress?: (progress: number) => void): Promise<{url: string, storagePath: string, name: string}> {
    return new Promise((resolve, reject) => {
      const fileName = file.name;
      const filePath = `artists/${artistId}/${Date.now()}_${fileName}`;
      const storageRef = ref(this.storage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed', (snapshot) => {
        if (onProgress) {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(Math.round(progress));
        }
      }, (error) => reject(error), async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve({ url, storagePath: filePath, name: fileName });
      });
    });
  }

  async deleteFile(storagePath: string): Promise<void> {
    if (storagePath) {
      const storageRef = ref(this.storage, storagePath);
      await deleteObject(storageRef);
    }
  }

  uploadFrameImage(artistId: string, period: string, file: File): Promise<{url: string, storagePath: string, name: string}> {
    return new Promise((resolve, reject) => {
      const fileName = file.name;
      const filePath = `artists/${artistId}/${period}/${Date.now()}_${fileName}`;
      const storageRef = ref(this.storage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on('state_changed', (snapshot) => {}, (error) => reject(error), async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve({ url, storagePath: filePath, name: fileName });
      });
    });
  }
}